export { default } from './UnscoredCashbackPage'
